import {getSignature, retrievePublicAddress} from './eth';

import {getNonce, signInWithJWTAndReturnUserId, verifySignature} from './fb';


export async function connect() {
    try {
        const publicAddress = await retrievePublicAddress();
        if (publicAddress) {
            const nonce = await getNonce(publicAddress);

            if (nonce) {
                const signature = await getSignature(
                    publicAddress,
                    nonce,
                );

                if (signature) {
                    const jwt = await verifySignature(
                        publicAddress,
                        signature,
                    );

                    if (jwt) {
                        await signInWithJWTAndReturnUserId(jwt);
                    }
                }
            }
        }
    } catch (error) {
        console.log(error);
    }
}
